<template src='./tabDetails.pug' lang='pug'></template>

<script>
export default {
  name: 'TabDetails',

  props: {
    idModal: {
      type: String
    },
    establishtmentValue: {
      type: Object
    },
    mainValuesList: {
      type: Array,
      required: true
    },
    statusValuesList: {
      type: Array
    },
    monetaryValuesList: {
      type: Array,
      required: true
    },
    commentary: {
      type: Object
    }
  },

  methods: {
    closeModal () {
      $('#' + this.idModal).modal('hide')
    },

    getStatusValueClass (item) {
      let title = ''
      switch (item.value) {
        case 'C':
          title = 'detail-status font-C'
          break
        case 'M':
          title = 'detail-status font-C'
          break
        case 'D':
          title = 'detail-status font-D'
          break
        case 'N':
          title = 'detail-status font-N'
          break
        case 'A':
          title = 'detail-status font-A'
          break
        default :
          title = 'detail-value'
          break
      }
      return title
    }
  }
}
</script>

<style lang='css'>
.grid-modal-content {
  padding: 5px 10px 0px 10px;
  min-height: 47vh;
  min-width: 47vw;
}

.tab-detail-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #17375f;
  font-size: 15px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.detail-title {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  margin-top: 1vh;
  color: #17375f;
}

#main-detail-container.main-container {
  max-height: 58vh;
  overflow: auto;
}

.detail-status {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  font-size: 3vh;
}

.font-C {
  color: #3bb57a;
}

.font-D {
  color: #f55753;
}

.font-N {
  color: #56a9c1;
}

.font-A {
  color: #fdbd39;
}

#tab-details-id {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0px;
  overflow: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
}
</style>



// WEBPACK FOOTER //
// TabDetails.vue?503bf24a